<template lang="pug">
  .center.bg.margin-top
    section.custom-width.margin-top
      el-row(:gutter="16")
        el-col(:xs="24", :sm="12", :md="12")
          h5.text-secondary Depoimentos
          h2 
            |Veja o que nosso cliente disse
            span.space
            span.text-primary sobre nós
          p Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla lacinia diam risus, vitae bibendum sapien iaculis sit amet. Morbi eleifend ipsum vitae lorem gravida, quis scelerisque velit maximus. Praesent ornare, est a fringilla volutpat.
        el-col(:xs="24", :sm="12", :md="12")
          .box-img
            .center
              img.avatar(data-aos="fade", data-aos-delay="100", :src="require('@/assets/svg/user.svg')")
            .center
              div
                .text.text-center(data-aos="zoom-in", data-aos-delay="150") Share your beautiful travel stories with bold imagery in this contemporary personal magazine. Featured images use the new shape dividers for extra style.
                .text.text-center(data-aos="fade-up", data-aos-delay="150")
                  |namo da pessoa
                  span.space
                  strong.text-uppercase profissão
      .margin-top
</template>

<script>
  export default {
    name: 'testmony',
    data: () => ({}),
  }
</script>

<style lang="sass" scoped>
  @import '../../assets/sass/bootloader'
  .bg
    background-color: #F1EFF5
  h5
    font-size: $f-size*1.1
  h2
    font-family: 'Kanit', sans-serif
  p
    margin: 64px 0
  .box-img
    background-image: url('../../assets/svg/depoimento-bg.svg')
    background-size: 100%
    background-position: center
    background-repeat: no-repeat
    min-height: 440px
    padding-top: 72px
    @media (max-width: 767px)
      background-size: 140%
    .avatar
      background-color: $c-white
      width: 80px
      height: 80px
      border-radius: 50px
      padding: 5px
      filter: invert(1) sepia(1) saturate(5) hue-rotate(175deg)
    .text
      max-width: 300px
      color: $c-white
      margin: 32px 0
</style>